import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-subject-marketing',
  templateUrl: './subject-marketing.component.html',
  styleUrls: ['./subject-marketing.component.scss']
})
export class SubjectMarketingComponent implements OnInit {

  @Input()form : UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
  }

}
